/**
 * CSINT Analytics API — staff-only corpus statistics.
 */

import { api } from "./staff";

export interface CsintSourceBreachInfo {
  name: string;
  domain: string | null;
  countryCode: string | null;
  countryName: string | null;
  breachDate: string | null;
  declaredRecords: number | null;
}

export interface CsintSourceStats {
  slug: string;
  index: string;
  docs: number;
  deletedDocs: number;
  sizeBytes: number;
  sizeHuman: string;
  breach: CsintSourceBreachInfo;
  categories: string[];
  fieldCount: number;
  createdAt?: string | null;
}

export interface CsintAnalyticsTotals {
  documents: number;
  sources: number;
  sizeBytes: number;
  sizeHuman: string;
}

export interface CsintAnalyticsResponse {
  total: CsintAnalyticsTotals;
  sources: CsintSourceStats[];
  fetchedAt: string;
}

export async function getCsintStats(): Promise<CsintAnalyticsResponse> {
  return api<CsintAnalyticsResponse>("/v2/enrich/analytics");
}
